import React from 'react';
import { Thanks } from '../components/ThanksSection';

export const Thankyou = () => {
    return (
      <>
        <Thanks />
      </>
      )
}